export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9402.f919d965.jpg";